<template>
  <div>
      <template v-if="isAuthenticated">
      <home-doctor v-if="contains('doctor')"></home-doctor>
      <home-receptionist v-else-if="contains('receptionist') || contains('nurse')"></home-receptionist>
      </template>
  </div>
</template>

<script>
  import HomeDoctor from './HomeDoctor/HomeDoctor.vue'
  import HomeReceptionist from './HomeReceptionist/HomeReceptionist.vue'

  export default {
    name: 'dashboard',
    data () {
      return {
        // roles:
      }
    },
    methods: {
      contains (role) {
        let roles = JSON.parse(this.$ls.get('role'))
        for (let i = 0; i < roles.length; i++) {
          if (roles[i] === role) {
            return true
          }
        }
        return false
      }
    },
    computed: {
      isAuthenticated () {
        return this.$ls.get('authenticated')
      }
    },
    components: {
      HomeDoctor,
      HomeReceptionist
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Home.vue?3b8144f3